import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { formatPrice } from "../../../../utils/price.utils";
const CartSummary = ({ mrpTotal, discountTotal, total, items = [] }) => {
    const navigate = useNavigate();
    const [showOffers, setShowOffers] = useState(false);
    return (
       <> 

        <div className="cart-right sticky-summary" style={{ background:"#f2f3f7", boxShadow:"none", border:"none"}}>
            
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between"}}> 
            <h4 style={{ fontSize:"17px", paddingBottom:"9px"}}> Cart Detail  </h4>
            <h4 className="Price-Details-font">Items ({items.length}) </h4>
            </div>


           {/* <div className="coupon-box"> 
                <div className="inputsection"> 
                <div style={{ position:"relative"}}> 
                <input type="text" placeholder="Enter Coupon Code" className="input"/>
                <button className="applybutton"> Apply </button>
                </div>
                </div>
                <div className="Avilable-Offer"> 
                    <a href="#"> <i class="bi bi-tag"></i>  View Avilable Offer <span style={{ float:"right"}}> <i class="bi bi-chevron-right"></i> </span> </a>  
                </div>
                       <div>
                        <div className="Avilable-Offer">
                            <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowOffers(!showOffers);
                            }}
                            style={{ textDecoration: "none", display: "block" }}
                            >
                            <i className="bi bi-tag"></i> View Available Coupon Code
                            <span style={{ float: "right" }}>
                                <i
                                className={`bi ${
                                    showOffers ? "bi-chevron-down" : "bi-chevron-right"
                                }`}
                                ></i>
                            </span>
                            </a>
                        </div>
                        {showOffers && (
                            <div className="coupon-list" style={{ padding: "10px", border: "1px solid #eee" }}>
                            <p style={{ fontSize:"13px", marginBottom:"0"}}>Coupon Code:<span style={{ color:"#e52828", fontWeight:"600",}}> OBSFAT10 </span>  </p>
                            </div>
                        )}
                        </div>
            </div> */}


            {/* <h4 className="Price-Details-font"> Price Details ({items.length}) </h4> */}
           
            <div className="summary">
                <div className="trackvel total-font-size">
                     <div className="txt_title_cal font-width001"> Total MRP </div>
                     <div style={{ fontWeight:"600"}}>{formatPrice(mrpTotal || 0)}</div>
                </div>
                <div className="trackvel total-discount-size">
                    <div className="txt_title_cal font-width001">Product Discount</div>
                    {discountTotal > 0 && (
                        <div style={{ color: "rgb(255, 63, 108)", fontWeight:"600" }}>
                            {formatPrice(discountTotal)}
                        </div>
                    )}
                </div>
                <div className="summary-row total" style={{ borderTop:"1px solid rgb(226 226 226)", padding:"11px 0px", fontSize:"15px" }}>
                    <div className="txt_title_cal">Sub Total</div>
                    <div style={{ color:"#000", fontWeight:"600"}}> <span style={{color:"#000"}}>  {formatPrice(total || 0)} </span></div>
                </div>
                <button onClick={() => navigate("/checkout/init")} className="checkout"> CHECKOUT </button>
                <button className="continue_shoping" onClick={() => navigate("/")} >
                    CONTINUE SHOPPING
                </button>
            </div>
        </div>

        </>
    );
};
export default CartSummary;